import comp from "./DownloadTranscriptsModal";
export default comp;
